import { render } from "./PriceStarInfoRow.vue?vue&type=template&id=9fdb2916&scoped=true"
import script from "./PriceStarInfoRow.vue?vue&type=script&lang=js"
export * from "./PriceStarInfoRow.vue?vue&type=script&lang=js"

import "./PriceStarInfoRow.vue?vue&type=style&index=0&id=9fdb2916&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fdb2916"]])

export default __exports__